import { useUnit } from 'effector-react';
import { ReactNode } from 'react';
import { gameModel } from 'entities/game';
import { NumberFormatter } from 'shared/ui';
import CoinIcon from 'shared/ui/assets/icons/coin-icon.svg?react';
import cls from './header.module.scss';

type HeaderProps = {
	actionSlot: ReactNode;
	contentSlot: ReactNode;
};

export const Header = ({ actionSlot, contentSlot }: HeaderProps) => {
	const [balance, currency, broke] = useUnit([
		gameModel.$balance,
		gameModel.$currency,
		gameModel.$brokeVisible,
	]);

	return (
		<header className={cls.headerWrapper}>
			{contentSlot}
			<div className={cls.headerContent}>
				{actionSlot}
				<div className={cls.headerBalance}>
					<CoinIcon className={cls.headerBalanceIcon} />
					<NumberFormatter
						fixedDecimalScale
						value={balance}
						suffix={` ${currency}`}
						thousandSeparator=' '
						decimalScale={2}
						data-broke={broke || undefined}
						className={cls.headerBalanceValue}
					/>
				</div>
			</div>
		</header>
	);
};
